module.exports = __webpack_public_path__ + "img/icon-propagation-white.02e276e6.svg";